import styled from 'styled-components';
import { Link as ReactLink } from 'react-router-dom';
import { space, layout, color, typography, position } from 'styled-system';

export const ExternalLink = styled.a(({ theme }) => `
  color: ${theme.colors.utility.primary};
`, layout, space, color, typography);
export const Span = styled.span(({ nowrap, clickable }) => `
  ${nowrap ? 'white-space: nowrap;' : ''}
  ${clickable ? 'cursor: pointer;' : ''}
`, layout, space, color, typography);
export const Paragraph = styled.p(() => `
  margin: 0 0 1rem;
`, layout, space, color, typography);
export const Label = styled.label`
  display: block;
  margin-bottom: 1rem;
  ${space}
  ${color}
  ${typography}
`;
export const Strong = styled.strong(({ nowrap }) => `
  ${nowrap ? 'white-space: nowrap;' : ''}
`, layout, space, color, typography);
export const Small = styled.small(() => `
  font-size: 0.66rem;
  line-height: 0.66rem;
`, space, color, typography, position);
export const Icon = styled.span(({ theme }) => `
  svg {
    height: 1rem;
    display: inline;
    stroke: ${theme.colors.dark};
    fill: ${theme.colors.dark};
  }
`);
export const Link = styled(ReactLink)(({ theme }) => `
  color: ${theme.colors.utility.primary};
`);

export const Heading1 = styled('h1')(({ theme }) =>`
  font-family: ${theme.fontFamilies.heading};
  position: relative;
  z-index: 1;
  overflow: hidden;
  color: ${theme.colors.utility.primary};
  text-align: center;
  font-weight: normal;
  font-size: 2.25rem;
  transition:
    margin ${theme.speeds.slow},
    max-height ${theme.speeds.slow},
    opacity ${theme.speeds.fast};
  &:before, &:after {
    position: absolute;
    top: 50%;
    overflow: hidden;
    width: 50%;
    content: '';
    background-color: ${theme.colors.utility.primary};
    height: ${theme.strokes.medium};
    transition:
      max-height ${theme.speeds.moderate},
      opacity ${theme.speeds.fast};
  }
  &:before {
    margin-left: -50%;
    text-align: right;
  }
`, space, color, typography);
